// Auto-Caption — portal entry (owned by the autocaption feature).
import { Captions } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const autocaption: FeatureModule = {
  id: "autocaption",
  nav: [{ to: "/autocaption", label: "Auto-Caption", icon: Captions, group: "content", order: 12 }],
  routes: [
    {
      path: "/autocaption",
      lazy: async () => {
        const { AutoCaptionPage } = await import("./AutoCaptionPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <AutoCaptionPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default autocaption;
